import { useState } from 'react'
import { View, Image, ImageStyle, StyleProp, ViewStyle, useWindowDimensions } from 'react-native'
import { getClubLogoSource } from '../config/clubBranding'

const DESKTOP_BREAKPOINT = 768

type ClubLogoProps = {
    size?: number
    /** When true, use `size` as-is (no 2× scaling on wide screens). */
    fixedSize?: boolean
    style?: StyleProp<ImageStyle>
    containerStyle?: StyleProp<ViewStyle>
}

export function ClubLogo({ size = 200, fixedSize = false, style, containerStyle }: ClubLogoProps) {
    const [loaded, setLoaded] = useState(false)
    const { width } = useWindowDimensions()
    const logoSource = getClubLogoSource()
    const resolvedSize = fixedSize ? size : (width >= DESKTOP_BREAKPOINT ? size * 2 : size)

    return (
        <View style={[containerStyle, { width: resolvedSize, height: resolvedSize }]}>
            <Image
                source={logoSource}
                style={[{ width: resolvedSize, height: resolvedSize, opacity: loaded ? 1 : 0 }, style]}
                resizeMode="contain"
                onLoad={() => setLoaded(true)}
                onError={() => setLoaded(true)}
            />
        </View>
    )
}
